export const COLORS = {
    'darkpurple': '#3A0CA3',
    'lightpurple': '#8854FF',
    'black': 'black',
    'lightgrey': '#FAFAFF',
    'white': "#FFFFFF",
}